import { ENDPOINTS } from 'src/constants/endpoints'

import type { IFundUpdatesListResponseDTO } from 'src/app/home/pages/fund-updates/domain/contracts/fund-updates'
import { http } from 'src/interfaces/http'

export interface IGetFundUpdatesParams {
  page: number
  pageSize: number
  category?: string
}

export const getFundUpdates = async (
  params: IGetFundUpdatesParams,
): Promise<IFundUpdatesListResponseDTO> => {
  const { data } = await http.get<IFundUpdatesListResponseDTO>(
    ENDPOINTS.hanwha.fundUpdates,
    {
      params: {
        page: params.page,
        page_size: params.pageSize,
        ...(params.category ? { category: params.category } : {}),
      },
    },
  )
  return data
}
